import { useParams } from "react-router-dom/cjs/react-router-dom"
import BannerHeader from "../../../Components/BannerHeader/BannerHeader"
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav"
import classes from "./Blog.module.css"
import { useSelector } from "react-redux"
import HtmlViewer from "../../../Components/HtmlViewer/HtmlViewer"
import { urls } from "../../../Routes/Urls"
import Footer from "../../Footer/Footer"
import useScrollToTop from "../../../Hooks/useScrollToTop"
import CanonicalLink from "../../../Components/CanonicalLink"
import SEO from "../../../Components/SEO"
import { useEffect, useState } from "react"
import { fetchBlogs, fetchBlogsBySlug } from "../../../Store/actions/BlogsAction"

const Blog = () => {
    const blogData = useSelector((state) => state.blogs.allBlogs);
    const { slug } = useParams()
    const [currentBlog,setCurrentBlog] = useState(null)

    

    const crumbs = [
        {title:"Home",path:("/")},
        {title:"Blogs",path:(urls.BLOG)},
        {title:currentBlog?.title,path:`${urls.BLOG}/${currentBlog?.urlSlug}`}
    ]

    useEffect(() => {
        fetchBlogsBySlug(slug).then((res) => {
            if(res) {
                setCurrentBlog(res?.[0])
            }
        })
    },[slug])

    const scrollRef = useScrollToTop()

    return (
        <div ref={scrollRef}>
            <PrimaryNav />
            <BannerHeader crumbs={crumbs} />

            {currentBlog && (
                <>
                    <SEO
                        title={currentBlog?.title}
                        description={currentBlog?.description}
                        canonicalUrl={currentBlog?.canonicalUrl}
                    />
                </>
            )}

            <div className={classes.blogViewContainer} >
            <div style={{ margin:"auto", width:"100%", maxWidth:"844px"}}>
                <h1 className={classes.blogHeader}>{currentBlog?.title}</h1>
                <div className={classes.blogBannerImageContainer}>
                    <img src={currentBlog?.bannerImagePath} alt={currentBlog?.bannerAlt} />
                </div>
                <div className={classes?.blogContent}>
                <HtmlViewer src={currentBlog?.contentPath}/>
                </div>
                </div>
            </div>
            <Footer />
            </div>
    )
}

export default Blog